import React, { useState } from 'react';
import FloatingFormWindow from '../shared/FloatingFormWindow';
import TaskFormModal from '../tasks/TaskFormModal';
import TransactionFloatingForm from './TransactionFloatingForm';
import PaymentFloatingForm from './PaymentFloatingForm';
import CustomerFloatingForm from './CustomerFloatingForm';
import './MultiActionFAB.css';

/**
 * MultiActionFAB - Floating Action Button with multiple quick actions
 * Opens floating form windows for Tasks, Transactions, and Payments
 */
export default function MultiActionFAB({ onActionComplete }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeForm, setActiveForm] = useState(null); // 'task', 'transaction', 'payment', 'customer'

  const handleActionClick = (action) => {
    setActiveForm(action);
    setIsExpanded(false);
  };

  const handleCloseForm = () => {
    setActiveForm(null);
  };

  const handleFormComplete = () => {
    setActiveForm(null);
    onActionComplete?.();
  };

  return (
    <>
      {/* FAB Menu */}
      <div className={`multi-action-fab ${isExpanded ? 'expanded' : ''}`}>
        {/* Action Buttons (shown when expanded) */}
        {isExpanded && (
          <div className="fab-actions">
            <button
              className="fab-action-btn customer"
              onClick={() => handleActionClick('customer')}
              title="New Customer"
            >
              <i className="fas fa-user-plus"></i>
              <span className="fab-action-label">Customer</span>
            </button>
            <button
              className="fab-action-btn task"
              onClick={() => handleActionClick('task')}
              title="New Task"
            >
              <i className="fas fa-tasks"></i>
              <span className="fab-action-label">Task</span>
            </button>
            <button
              className="fab-action-btn transaction"
              onClick={() => handleActionClick('transaction')}
              title="New Transaction"
            >
              <i className="fas fa-file-invoice-dollar"></i>
              <span className="fab-action-label">Transaction</span>
            </button>
            <button
              className="fab-action-btn payment"
              onClick={() => handleActionClick('payment')}
              title="New Payment"
            >
              <i className="fas fa-hand-holding-usd"></i>
              <span className="fab-action-label">Payment</span>
            </button>
          </div>
        )}

        {/* Main FAB Button */}
        <button
          className={`fab-main-btn ${isExpanded ? 'rotated' : ''}`}
          onClick={() => setIsExpanded(!isExpanded)}
          title={isExpanded ? "Close menu" : "Quick actions"}
        >
          <i className={`fas ${isExpanded ? 'fa-times' : 'fa-plus'}`}></i>
        </button>
      </div>

      {/* Floating Forms */}
      <FloatingFormWindow
        show={activeForm === 'customer'}
        onHide={handleCloseForm}
        title="New Customer"
        icon="fa-user-plus"
      >
        <CustomerFloatingForm
          onSubmit={handleFormComplete}
          onCancel={handleCloseForm}
        />
      </FloatingFormWindow>

      <FloatingFormWindow
        show={activeForm === 'task'}
        onHide={handleCloseForm}
        title="Create New Task"
        icon="fa-tasks"
      >
        <TaskFormModal
          show={activeForm === 'task'}
          onHide={handleCloseForm}
          onTaskCreated={handleFormComplete}
          isFloating={true}
        />
      </FloatingFormWindow>

      <FloatingFormWindow
        show={activeForm === 'transaction'}
        onHide={handleCloseForm}
        title="New Transaction"
        icon="fa-file-invoice-dollar"
      >
        <TransactionFloatingForm
          onSubmit={handleFormComplete}
          onCancel={handleCloseForm}
        />
      </FloatingFormWindow>

      <FloatingFormWindow
        show={activeForm === 'payment'}
        onHide={handleCloseForm}
        title="Tender Payment"
        icon="fa-hand-holding-usd"
      >
        <PaymentFloatingForm
          onSubmit={handleFormComplete}
          onCancel={handleCloseForm}
        />
      </FloatingFormWindow>
    </>
  );
}
